import { type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  icon: LucideIcon;
  title: string;
  description: string;
  count: number;
  tone: 'rage' | 'dead' | 'quick' | 'error';
}

const TONE = {
  rage: 'bg-danger/10 text-danger',
  dead: 'bg-warning/10 text-warning',
  quick: 'bg-accent/10 text-accent',
  error: 'bg-danger/10 text-danger',
};

export function InsightCard({ icon: Icon, title, description, count, tone }: Props) {
  return (
    <div className="flex items-start gap-3.5 rounded-lg border border-border bg-bg-surface p-4 transition-colors hover:border-border-strong">
      <div className={cn('flex size-9 shrink-0 items-center justify-center rounded-md', TONE[tone])}>
        <Icon className="size-4" />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="text-sm font-semibold">{title}</h3>
        <p className="mb-2 text-xs text-text-muted">{description}</p>
        <div className="font-mono text-xl font-medium tabular-nums">{count}</div>
      </div>
    </div>
  );
}
